import React, { createContext, useCallback, useMemo, useState } from 'react';
import { Data } from '../data/Data';
import { useLotsCommerciaux } from './lotCommercialContext';
import { useNotificationsManager } from './notificationContext';

const IntervenantContext = createContext();
const IntervenantManagerContext = createContext();

export const IntervenantContextProvider = ({ children }) => {

    const { idOperationActive, idLotCommercialActif } = useLotsCommerciaux();
    const { dismiss, extractErrorMessages, inform } = useNotificationsManager();

    const [allIntervenants, setAllIntervenants] = useState([]);
    const [loaded, setLoaded] = useState([]);

    const loadIntervenants = useCallback((idOperation, idLotCommercial) => {
        const id = inform("Chargement des intervenants...");

        Data._getIntervenants(idOperation, idLotCommercial).then(response => {
            if (response.codeRetour === 0) {
                const objet = response.reponseAPIobjet;
                let { chargeeDeRelationClient, notaireClient, notaireOperation } = objet;

                setAllIntervenants(prev => [
                    ...prev,
                    { ...chargeeDeRelationClient, idOperation, idLotCommercial, type: "chargeeDeRelationClient" },
                    { ...notaireClient, idOperation, idLotCommercial, type: "notaireClient" },
                    { ...notaireOperation, idOperation, idLotCommercial, type: "notaireOperation" },
                ]);

                setLoaded(prev => [...prev, { idOperation, idLotCommercial }]);
            }
            else extractErrorMessages(response);
            dismiss(id);
        });
    }, [dismiss, extractErrorMessages, inform]);

    const intervenants = useMemo(() => {
        if (!idOperationActive || !idLotCommercialActif) return [];
        const alreadyLoaded = loaded.some(item => item.idOperation === idOperationActive && item.idLotCommercial === idLotCommercialActif);
        if (!alreadyLoaded) {
            loadIntervenants(idOperationActive, idLotCommercialActif);
            return [];
        }
        else return allIntervenants.filter(intervenant => intervenant.idOperation === idOperationActive && intervenant.idLotCommercial === idLotCommercialActif);
    }, [allIntervenants, idOperationActive, idLotCommercialActif, loadIntervenants, loaded]);

    const resetIntervenants = useCallback(() => {
        setAllIntervenants([]);
        setLoaded([]);
    }, []);

    const value = useMemo(
        () => ({ intervenants }),
        [intervenants]
    );

    const managerValue = useMemo(
        () => ({ resetIntervenants }),
        [resetIntervenants]
    );

    return <IntervenantManagerContext.Provider value={managerValue}>
        <IntervenantContext.Provider value={value}>
            {children}
        </IntervenantContext.Provider>
    </IntervenantManagerContext.Provider>;

};

export const useIntervenants = () => {
    const data = React.useContext(IntervenantContext);
    if (data === undefined) throw new Error();
    const { intervenants } = data;
    return { intervenants };
};

export const useIntervenantsManager = () => {
    const manager = React.useContext(IntervenantManagerContext);
    if (manager === undefined) throw new Error();
    const { resetIntervenants } = manager;
    return { resetIntervenants };
};